var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "header-wrap" } }, [
    _c("div", { staticClass: "header-logo" }, [
      _c("a", { staticClass: "header-logo-link", attrs: { href: "/" } }, [
        _c("img", {
          staticClass: "header-logo-img",
          attrs: {
            src: _vm.turi + "/img/header/gheader_h_logo.svg",
            alt: "ハウス公式通販"
          }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "header-logo-img",
          attrs: {
            src: _vm.turi + "/img/header/gheader_logo.svg",
            alt: "ハウスダイレクト　健康食品・サプリメント"
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "header-tel" }, [
      _c("p", { staticClass: "header-tel-order" }, [
        _vm._v("お電話でのご注文")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "header-tel-number" }, [
        _c("img", {
          staticClass: "header-logo-img",
          attrs: {
            src: _vm.turi + "/img/header/gheader_number.svg",
            alt: "ハウス公式通販"
          }
        })
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "header-tel-time" }, [
        _vm._v("平日9:00-17:30（土日祝、年末年始を除く）")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "header-account pc" }, [
      _c("ul", [
        !_vm.isLoggedIn
          ? _c("li", { staticClass: "header-account-wrap" }, [_vm._m(0)])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm.isLoggedIn
          ? _c("li", { staticClass: "header-account-wrap" }, [
              _c(
                "a",
                {
                  staticClass: "header-account-link header-account-inquiry",
                  attrs: { href: _vm.pagePath.accounts.login },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.$A.$auth.signOut()
                    }
                  }
                },
                [_vm._v("ログアウト")]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticStyle: { opacity: "0" },
          style: _vm.initialized ? "opacity:1;" : ""
        },
        [
          _c("li", { staticClass: "header-account-wrap" }, [
            _c("p", { staticClass: "header-account-name" }, [
              _vm._v(_vm._s(this.user ? this.user.name : "ゲスト"))
            ]),
            _vm._v(" 様")
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "header-account-wrap" }, [
            !_vm.isLoggedIn
              ? _c(
                  "a",
                  {
                    staticClass: "header-account-link header-account-login",
                    attrs: { href: "/login/" }
                  },
                  [
                    _c("i", { staticClass: "far fa-user" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("ログイン / 会員登録")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isLoggedIn
              ? _c(
                  "a",
                  {
                    staticClass: "header-account-link header-account-login",
                    attrs: { href: "/mypage/" }
                  },
                  [
                    _c("i", { staticClass: "far fa-user" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("マイページ")])
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "header-account-wrap" }, [
            _c(
              "a",
              {
                staticClass: "header-account-link header-account-cart",
                attrs: { href: "/cart/" }
              },
              [
                _c("i", { staticClass: "fas fa-shopping-cart" }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "cart-price",
                    staticStyle: { "padding-right": "8px" }
                  },
                  [_c("span", [_vm._v(_vm._s(this.quantity))]), _vm._v("点")]
                )
              ]
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "header-account sp",
        staticStyle: { opacity: "0" },
        style: _vm.initialized ? "opacity:1;" : ""
      },
      [
        _c("ul", [
          !_vm.isLoggedIn
            ? _c("li", { staticClass: "header-account-wrap" }, [
                _c(
                  "a",
                  {
                    staticClass: "header-account-link header-account-login",
                    attrs: { href: _vm.isLoggedIn ? "/mypage/" : "/login/" }
                  },
                  [
                    _c("i", { staticClass: "far fa-user" }),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.isLoggedIn ? "マイページ" : "ログイン"))
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("li", { staticClass: "header-account-wrap" }, [
            _c(
              "a",
              {
                staticClass: "header-account-link header-account-cart",
                attrs: { href: "/cart/" }
              },
              [
                _c("span", { staticClass: "cart-item" }, [
                  _vm._v(_vm._s(this.quantity))
                ]),
                _c("i", { staticClass: "fas fa-shopping-cart" }),
                _vm._v(" "),
                _c("p", [_vm._v("カート")])
              ]
            )
          ]),
          _vm._v(" "),
          _vm._m(2)
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "header-account-link header-account-beginne",
        attrs: { href: "/intro/" }
      },
      [_c("i", { staticClass: "far new_member" }), _vm._v("はじめての方へ")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "header-account-wrap" }, [
      _c(
        "a",
        {
          staticClass: "header-account-link header-account-inquiry",
          attrs: { href: "/inquiry/" }
        },
        [_c("i", { staticClass: "far fa-envelope" }), _vm._v("お問い合わせ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "header-account-wrap" }, [
      _c(
        "div",
        {
          staticClass: "header-account-link header-account-menu",
          attrs: { onclick: "HWFJS__toggleMobileMenu()" }
        },
        [
          _c("button", { staticClass: "switch-navigation-menu" }, [
            _vm._v("MENU")
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("メニュー")])
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }